import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
  },
  action
) {
  switch (action.type) {
    case homeConstants.SEARCH_RADIUS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.SEARCH_RADIUS_SUCCESS: {
      const result =
        action.response.data &&
        action.response.data.map((item) => {
          return {
            value: item.key,
            text: item.displayValue,
            default: item.default,
          };
        });
      return {
        ...state,
        data: result || [],
        isProgress: false,
      };
    }
    case homeConstants.SEARCH_RADIUS_FAILURE:
      return {
        ...state,
        error: action.error,
        data: [],
        isProgress: false,
      };
    default:
      return state;
  }
}
